import { Helmet } from "react-helmet"
import { Heading, HeadingLevel } from "../../../ui/atoms/heading"
import styles from './contact.module.css'; 

import MelvinRostek from '../../../../assets/staff-melvin-rostek.jpg?sizes[]=200,sizes[]=600,sizes[]=1024,sizes[]=2048&format=webp&useResponsiveLoader=true';
import JennaElliott from '../../../../assets/staff-jenna-elliott.jpg?sizes[]=200,sizes[]=600,sizes[]=1024,sizes[]=2048&format=webp&useResponsiveLoader=true';



export const Contact: React.FC<any> = (_props) => {
  return (
    <>
      <Helmet>
        <title>Contact Us</title>
      </Helmet>
      <Heading level={HeadingLevel.H1}>Contacting the Atlantis:</Heading>
      <div className={['space-y-5', styles['container']].join(' ') }>

      
        <div>
          Office Hours are from 8:30 AM to 5:00 PM Monday through Friday via phone/email.<br/><br/>
          Email: <a href="mailto:info@atlantisocmd.com">info@atlantisocmd.com</a><br/>
          Phone: <a href="tel:+1-410-524-9100">410-524-9100</a><br/>
        </div>

        <article>
          <Heading level={HeadingLevel.H5}>Office Staff:</Heading>
          <div className="grid grid-cols-1">
    

            

          </div>
        </article>
      </div>
    </>
  )
}